import { Button } from '@material-ui/core';
import React from 'react';
import { IconWithTooltip } from '../icons/IconWithTooltip';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';

export function TriggerMatcher({ triggerMatcher }) {

    return (
        <IconWithTooltip title="Társítás futtatása" >
            <Button className="material-action-icon-button" onClick={triggerMatcher}>
                <PlayCircleOutlineIcon className="material-action-icon" />
            </Button>
        </IconWithTooltip>
    )
}